<template>
  <div>
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
import { mapActions,mapState,mapMutations } from "vuex";
export default {
  name: 'app',
  data() {
  	return {
  		userinfo: null
  	}
  },
  computed:{
  	...mapState({
  		users:(state)=>state.login.userinfo,
  	}),
  },
  created(){
  	this.userinfo = this.users?this.users:""
  	
  },
  mounted(){
  	console.log('check wx follow',this.userinfo)
  	// this.$nextTick(function () {
  	// 	window.addEventListener('scroll', this.onScroll)
  	// })
  	
  },
  methods: {}
}
</script>

<style>
    svg{display: inline-block !important;}
</style>
